// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__2xEIY","load2":"Spinner_load2__3U6l7"};